import React, { useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { Group, OfficeBuilding, User } from '../../shared/icons';
import { TypeDeleteConfirmationModal } from '../../shared/modal/TypeDeleteConfirmationModal';
import { deleteEntityStarted, EntityType, getEntityToDelete, getIsDeleting, toggleDeleteConfirmationModal } from './store';

interface DeleteEntityConfirmationModalProps {
    isOpen: boolean;
}

export const DeleteEntityConfirmationModal: React.FC<DeleteEntityConfirmationModalProps> = ({ isOpen }) => {
    const dispatch = useAppDispatch();
    const entityToDelete = useAppSelector(getEntityToDelete);
    const isDeleting = useAppSelector(getIsDeleting);
    const deleteEntity = () => dispatch(deleteEntityStarted(entityToDelete!.entityId!));
    const closeModal = () => dispatch(toggleDeleteConfirmationModal(null));

    const headerIcon = useMemo(() => {
        switch (entityToDelete?.type) {
            case EntityType.COMPANY:
                return OfficeBuilding;
            case EntityType.GROUP:
                return Group;
            case EntityType.PERSON:
            default:
                return User;
        }
    }, [entityToDelete]);

    const warning = 'This will permanently delete this entity.';

    if (!entityToDelete) {
        return null;
    }

    return (
        <TypeDeleteConfirmationModal
            isOpen={isOpen}
            closeModal={closeModal}
            deleteAction={deleteEntity}
            isDeleting={isDeleting}
            headerLabel='Delete Entity'
            name={entityToDelete.name}
            testId='entity'
            warning={warning}
            icon={headerIcon}
        />
    );
};
